import React, { Component } from "react";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter 
} from "reactstrap";


type State = {       
    betreff: string;
    text: string;
}

type Props = {
    header: string,
    labelBetreff: string
    labelText: string
    open: boolean,
    b1: string,    
    b2: string,        
    onB1: (betreff: string, text: string) => void|undefined;
    onB2: (betreff: string, text: string) => void|undefined;
    onCancel:() => void;
}

export class CommentBox extends Component<Props, State> {
        
    static defaultProps = {
        b2: "",
        onB2: undefined        
    }

    state: State = {        
        betreff: "",
        text: ""
    }

    
    componentDidUpdate(prevProps: Props) {        
        if (prevProps !== this.props) {
            // This triggers an unnecessary re-render
            this.setState({
                betreff: "",
                text: ""

            });
        }
    }

    render() {        
        return (
                <Modal className="kslplus-modal-messagebox" size="xl" isOpen={this.props.open} >
                    <ModalHeader toggle={this.props.onCancel}>{this.props.header}</ModalHeader>
                    <ModalBody>
                        <div className="form-group">
                            <label className="kslplus-modal-label">{this.props.labelBetreff}</label>    
                            <input className="form-control" placeholder="" value={this.state.betreff} onChange={(e) => { this.setState({ betreff: e.target.value }); }} />
                        </div>
                        <div className="form-group">
                            <label className="kslplus-modal-label">{this.props.labelText}</label>
                            <textarea className="form-control" rows={8} placeholder="" value={this.state.text} onChange={(e) => { this.setState({ text: e.target.value }); }} />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {this.props.onB1 && <Button color="primary" disabled={this.state.betreff.length === 0 || this.state.text.length === 0}  onClick={() => this.props.onB1(this.state.betreff, this.state.text)}>{this.props.b1}</Button>}
                        {this.props.onB2 && <Button color="primary" onClick={() => this.props.onB2(this.state.betreff, this.state.text)}>{this.props.b2}</Button>}
                    </ModalFooter>
                </Modal>
                
        );
    }
}
